export default {
    USER_TOKEN (state) {
        return state.userToken
    }
}
